<div class="project-layout-container">
  <div class="main-content">
    <app-project-header class="header"></app-project-header>
    <div class="content-wrapper">
      <main class="router-container">
        <router-outlet></router-outlet>
      </main>
    </div>
  </div>
</div>
